import React from 'react';
import { AiOutlineClose } from 'react-icons/ai';

const ConfirmModal = ({ title, message, confirmLabel = 'Confirm', confirmClass, onConfirm, onCancel }) => {
  return (
    <div className="fixed w-full min-h-full top-0 left-0 flex justify-center items-center bg-black/80 z-50">
      <div className="relative w-[90%] flex flex-col justify-start items-start space-y-5 bg-[#181C26] border border-[#1f2535] p-6 rounded-xl sm:w-[380px]">
        <div className="w-full flex justify-between items-center">
          <h4 className="text-white font-[600] text-[16px]">{title}</h4>
          <button onClick={onCancel}>
            <AiOutlineClose className="text-[#A9ABAD] text-[20px] hover:text-white transition-colors" />
          </button>
        </div>
        <p className="text-[#A9ABAD] text-[14px]">{message}</p>
        <div className="w-full flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 min-h-[40px] flex justify-center items-center text-[14px] font-[500] bg-[#0d1017] border border-[#1f2535] text-white rounded-lg hover:border-[#473ECD] transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={`flex-1 min-h-[40px] flex justify-center items-center text-[14px] font-[500] text-white rounded-lg transition-colors ${confirmClass || 'bg-red-700 hover:bg-red-800'}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
